import { AddressRequest, getAddress } from "@/services/rest/map";
import { useQuery } from "@tanstack/react-query";

export function useGetAddress(queryParams?: AddressRequest) {
  return useQuery({
    queryKey: ["get-address", queryParams],
    queryFn: () => getAddress(queryParams),
  });
}
